export default __webpack_public_path__ + "dim-2a24d3.json";